/**
 * Champions Dashboard - Priority Voting Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/voting
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { PriorityVoting } from '../../components/champions/dashboard/PriorityVoting';

export function ChampionsVotingPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <PriorityVoting />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsVotingPage;
